import React from 'react';
import { Box } from '@mui/material';
import Circle from '../basic/Circle';
import { Color6 } from '../../colors/Colors';
import HeaderGillC7H22 from '../typography/HeaderGillC7H22';
import HeaderGiliamsC2H33 from '../typography/HeaderGiliamsC2H33';
import ParagraphGillC2H19 from '../typography/ParagraphGillC2H19';

const HowItWorksBlock6 = () => {
  return (
    <Box
      sx={{
        maxWidth: '961.59px',
        marginX: 'auto',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginTop: '28px',
        paddingX: { xs: '20px', lg: 0 },
        flexDirection: { xs: 'column', md: 'row' },
        columnGap: '20px',
        rowGap: '40px',
      }}
    >
      <Box sx={{ width: '300px' }}>
        <Box sx={{ marginBottom: '15px' }}>
          <Circle color={Color6} diameter="52px">
            <HeaderGillC7H22>05</HeaderGillC7H22>
          </Circle>
        </Box>

        <HeaderGiliamsC2H33>Brand goes Viral</HeaderGiliamsC2H33>

        <ParagraphGillC2H19>
          Stay on top of your schedule with ease using our app's intuitive
          dashboard. Create a winning campaign with a fantastic offer to unleash
          the full potential of your brand. See your brand soar to viral success
          at a budget-friendly cost!
        </ParagraphGillC2H19>
      </Box>

      <Box sx={{ maxWidth: '413px', width: { xs: '100%', sm: '413px' } }}>
        <img
          src="images/how-it-works/block6-brands.svg"
          alt="Brand goes Viral"
          style={{ width: '100%', height: '100%' }}
        />
      </Box>
    </Box>
  );
};

export default HowItWorksBlock6;
